import { Action } from '../actions';
import { UserApi } from '../api-typings/users/users';
import { mergeMultipleObjects, RawStoreObjectStateSlice } from '../helpers';
import { transformUser } from '../user/user.transformers';

export function threadUsersReducer(
  state: RawStoreObjectStateSlice<'threadUsers'> = {},
  action: Action,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (
        action.payload.type === 'threads' ||
        action.payload.type === 'threadContests' ||
        action.payload.type === 'threadProjects' ||
        action.payload.type === 'threadUsers'
      ) {
        const { result } = action.payload;
        if (result.users) {
          return mergeMultipleObjects<'threadUsers'>(
            state,
            Object.values(result.users).map(transformUser),
          );
        }
        return state;
      } else if (action.payload.type === 'contacts') {
        const users = action.payload.result.contacts
          ? action.payload.result.contacts.map((c: { user: UserApi }) => c.user)
          : [];
        return mergeMultipleObjects<'threadUsers'>(
          state,
          Object.values(users).map(transformUser),
        );
      }
      return state;
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/sq/webapp/src/app/@shared/datastore/thread/threadUser.reducer.ts